"use client";
import * as o from "react";
import { N as e } from "./noop-CMWc2wUO.mjs";
const n = /* @__PURE__ */ o.createContext({
  disabled: void 0,
  readOnly: void 0,
  required: void 0,
  name: void 0,
  checkedValue: "",
  setCheckedValue: e,
  onValueChange: e,
  touched: !1,
  setTouched: e,
  registerControlRef: e
});
process.env.NODE_ENV !== "production" && (n.displayName = "RadioGroupContext");
function d() {
  return o.useContext(n);
}
export {
  n as R,
  d as u
};
